export class ValueSort{
    
    static compareFn(a, b): number{
        if (a.value < b.value) {
            return -1;
        }
        if (a.value > b.value) {
            return 1;
        }
        return 0;
    }
    
}

